import { generateId } from '@freelancer/datastore/testing/helpers';
import type { ExternalContactStatus } from './external-contact-status.model';

export function generateExternalContactStatusObject({
  userId = generateId(),
  isSyncEnabled = false,
  isUserDiscoverable = false,
  lastImportTime = undefined,
  lastUpdateTime = Date.now(),
}): ExternalContactStatus {
  return {
    id: userId,
    isSyncEnabled,
    isUserDiscoverable,
    lastImportTime,
    lastUpdateTime,
  };
}
